import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { FaShoppingCart } from "react-icons/fa";
import "../css/FloatingCartButton.css";
import { CartContext } from "../context/CartContext"; // adjust path if needed

const FloatingCartButton = () => {
  const { cartItems } = useContext(CartContext);

  return (
    <Link to="/cart" className="floating-cart-btn">
      <FaShoppingCart className="FaShoppingCart"/>
      {cartItems?.length > 0 && (
        <span className="cart-badge">{cartItems.length}</span>
      )}
    </Link>
  );
};

export default FloatingCartButton;
